import * as ActionTypes from '../constants/actionTypes'
import api from '../utils/api'
import getFieldFromItem, { fieldLang, getFieldWithLangKey, getNewObjFromDirtyLangObj } from '../utils/getFieldFromItem'

export const keys = []

export const editForm = formFieldsChange => ({
  type: ActionTypes.CV_PUBLICATIONS_AND_ARTICLEFORM_EDITFORM_CHANGE,
  field: formFieldsChange,
})

export const reset = () => ({
  type: ActionTypes.CV_PUBLICATIONS_AND_ARTICLEFORM_ENTER_RESET,
})

export const fetchItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.CV_PUBLICATIONS_AND_ARTICLEFORM_FETCHITEM_LOAD })
  try {
    let item = await api.get(`cv_publications_and_articles/${params.id}`)
    item = {
      ...item,
      ...getFieldWithLangKey({ fieldTitle: 'data', objString: item.data, languages: fieldLang }),
    }
    dispatch({
      type: ActionTypes.CV_PUBLICATIONS_AND_ARTICLEFORM_FETCHITEM_SUCCEED,
      item,
    })
    const field = getFieldFromItem(
      item,
      //keys,
    )
    dispatch({
      type: ActionTypes.CV_PUBLICATIONS_AND_ARTICLEFORM_EDITFORM_CHANGE,
      field,
    })
  } catch (error) {
    dispatch({
      type: ActionTypes.CV_PUBLICATIONS_AND_ARTICLEFORM_FETCHITEM_FAIL,
      fetchItemError: error.message,
    })
  }
}

export const createItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.CV_PUBLICATIONS_AND_ARTICLEFORM_CREATEITEM_LOAD })
  try {
    await api.create(`cv_publications_and_articles`, getNewObjFromDirtyLangObj({ fieldTitle: 'data', languages: fieldLang, obj: params }))
    dispatch({ type: ActionTypes.CV_PUBLICATIONS_AND_ARTICLELIST_CHANGETABLE_CHANGE })
    dispatch({ type: ActionTypes.CV_PUBLICATIONS_AND_ARTICLEFORM_CREATEITEM_SUCCEED })
    dispatch({ type: ActionTypes.CV_PUBLICATIONS_AND_ARTICLEFORM_ENTER_RESET })
  } catch (error) {
    dispatch({
      type: ActionTypes.CV_PUBLICATIONS_AND_ARTICLEFORM_CREATEITEM_FAIL,
      createItemError: error.message,
    })
  }
}

export const editItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.CV_PUBLICATIONS_AND_ARTICLEFORM_EDITITEM_LOAD })
  try {
    await api.patch(`cv_publications_and_articles/${params.id}`, getNewObjFromDirtyLangObj({ fieldTitle: 'data', languages: fieldLang, obj: params }))
    dispatch({ type: ActionTypes.CV_PUBLICATIONS_AND_ARTICLEFORM_EDITITEM_SUCCEED })
  } catch (error) {
    dispatch({
      type: ActionTypes.CV_PUBLICATIONS_AND_ARTICLEFORM_EDITITEM_FAIL,
      editItemError: error.message,
    })
  }
}

export const deleteItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.CV_PUBLICATIONS_AND_ARTICLEFORM_DELETEITEM_LOAD })
  try {
    await api.delete(`cv_publications_and_articles/${params.id}`)
    dispatch({ type: ActionTypes.CV_PUBLICATIONS_AND_ARTICLEFORM_DELETEITEM_SUCCEED })
    dispatch({ type: ActionTypes.CV_PUBLICATIONS_AND_ARTICLEFORM_ENTER_RESET })
  } catch (error) {
    dispatch({
      type: ActionTypes.CV_PUBLICATIONS_AND_ARTICLEFORM_DELETEITEM_FAIL,
      deleteItemError: error.message,
    })
  }
}
